<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter" title="Other Works By James Carlos Blake">
<p class="centerb"><span class="right_1" epub:type="pagebreak" id="page_i" title="i"><span class="right_1" epub:type="pagebreak" id="page_ii" title="ii">Other Works<br/>By James Carlos Blake</span></span></p>
<p class="center"><i>Novels</i><br/>The Ways of Wolfe<br/>The House of Wolfe<br/>The Rules of Wolfe<br/>Country of the Bad Wolfes<br/>The Killings of Stanley Ketchel<br/>Handsome Harry<br/>Under the Skin<br/>A World of Thieves<br/>Wildwood Boys<br/>Red Grass River<br/>In the Rogue Blood<br/>The Friends of Pancho Villa<br/>The Pistoleer</p>
<p class="centerbt"><i>Collection</i><br/>Borderlands</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780802156969_Front1.vue?a04db240